import { render, staticRenderFns } from "./functionalitySlide.vue?vue&type=template&id=6d1da0c4&scoped=true&"
import script from "./functionalitySlide.vue?vue&type=script&lang=js&"
export * from "./functionalitySlide.vue?vue&type=script&lang=js&"
import style0 from "./functionalitySlide.vue?vue&type=style&index=0&id=6d1da0c4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d1da0c4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VScrollYTransition } from 'vuetify/lib/components/transitions';
installComponents(component, {VCard,VCol,VContainer,VDivider,VImg,VRow,VScrollYTransition})
